<template>
  <div id="dashboard">
    <div class="commonSearch" ref="commonSearchRef">
      <div class="headerTitle">
        <i class="fa fa-file-text-o"></i>
        <span>个性化配置</span>
      </div>
    </div>
    <div :style="pageContent" class="commonContent">
      <div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="系统配置" name="systemConfig">系统配置</el-tab-pane>
          <el-tab-pane label="短信消息" name="noteMessage">短信消息</el-tab-pane>
          <el-tab-pane label="推送消息" name="pushMessage">推送消息</el-tab-pane>
          <el-tab-pane label="文件存储" name="fileSave">文件存储</el-tab-pane>
          <el-tab-pane label="微信" name="wechat">微信</el-tab-pane>
          <el-tab-pane label="安全管理" name="safeManage">安全管理</el-tab-pane>
          <el-tab-pane label="邮件配置" name="mailConfig">邮件配置</el-tab-pane>
        </el-tabs>
      </div>
      <div style="margin-top:20px;">
        <el-form
          ref="systemForm"
          :model="systemForm"
          :rules="rules"
          label-width="250px"
          label-position="left"
          v-loading="loading"
          v-show="activeName=='systemConfig'"
        >
          <el-form-item label="系统名称" prop="sysName">
            <el-input
              v-model.trim="systemForm.sysName"
              autocomplete="off"
              placeholder="请输入系统名称"
              clearable
              style="width:500px"
              @change="inputChangeValue('sysName',systemForm.sysName)"
            ></el-input>
          </el-form-item>
          <el-form-item label="系统版本" prop="sysVersion">
            <el-input
              v-model.trim="systemForm.sysVersion"
              autocomplete="off"
              placeholder="请输入系统版本"
              clearable
              style="width:500px"
              @change="inputChangeValue('sysVersion',systemForm.sysVersion)"
            ></el-input>
          </el-form-item>
          <el-form-item label="版权信息" prop="sysCopyright">
            <el-input
              v-model.trim="systemForm.sysCopyright"
              autocomplete="off"
              placeholder="请输入版权信息"
              clearable
              style="width:500px"
              @change="inputChangeValue('sysCopyright',systemForm.sysCopyright)"
            ></el-input>
          </el-form-item>
          <el-form-item label="icp备案号" prop="sysIcp">
            <el-input
              v-model.trim="systemForm.sysIcp"
              autocomplete="off"
              placeholder="请输入icp备案号"
              clearable
              style="width:500px"
              @change="inputChangeValue('sysIcp',systemForm.sysIcp)"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="onSubmit('systemForm')"
              style="width:100px;margin-top:10px"
            >仅保存</el-button>
            <el-button
              type="primary"
              style="width:100px;margin-top:10px"
              @click="onSubmitAndRefresh('systemForm')"
            >保存并生效</el-button>
          </el-form-item>
        </el-form>

        <el-form
          ref="smsForm"
          :model="smsForm"
          :rules="rules"
          label-width="250px"
          label-position="left"
          v-loading="loading"
          v-show="activeName=='noteMessage'"
        >
          <el-form-item label="短信扫描是否开启" prop="smsOpen">
            <el-switch
              v-model="smsForm.smsOpen"
              active-color="#ff6a00"
              inactive-color="#f5f5f5"
              @change="inputChangeValue('smsOpen',smsForm.smsOpen)"
            ></el-switch>
          </el-form-item>
          <el-form-item label="短信平台" prop="smsType">
            <el-radio-group
              v-model="smsForm.smsType"
              @change="inputChangeValue('smsType',smsForm.smsType)"
            >
              <el-radio label="1">阿里云</el-radio>
              <el-radio label="2">腾讯云</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="消息扫描频率" prop="smsCron">
            <el-input
              v-model="smsForm.smsCron"
              autocomplete="off"
              placeholder="请输入消息扫描频率（0/10 * * * * ?）"
              clearable
              style="width:500px"
              @change="inputChangeValue('smsCron',smsForm.smsCron)"
            ></el-input>
          </el-form-item>
          <el-form-item label="失效重发有效期(次数)" prop="smsRetrySendTimes">
            <el-input-number
              v-model="smsForm.smsRetrySendTimes"
              controls-position="right"
              :min="1"
              :max="43200"
              :precision="0"
              @change="inputChangeValue('smsRetrySendTimes',smsForm.smsRetrySendTimes)"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="阿里云短信Key" prop="smsAliyunKey" v-if="smsForm.smsType=='1'">
            <el-input
              v-model.trim="smsForm.smsAliyunKey"
              placeholder="请输入阿里云短信key"
              clearable
              style="width:500px"
              @change="inputChangeValue('smsAliyunKey',smsForm.smsAliyunKey)"
            ></el-input>
          </el-form-item>
          <el-form-item label="阿里云短信Secret" prop="smsAliyunSecret" v-if="smsForm.smsType=='1'">
            <el-input
              v-model.trim="smsForm.smsAliyunSecret"
              placeholder="请输入阿里云短信Secret"
              clearable
              style="width:500px"
              @change="inputChangeValue('smsAliyunSecret',smsForm.smsAliyunSecret)"
            ></el-input>
          </el-form-item>
          <el-form-item label="阿里云短信Domain" prop="smsAliyunDomain" v-if="smsForm.smsType=='1'">
            <el-input
              v-model.trim="smsForm.smsAliyunDomain"
              placeholder="请输入阿里云短信Domain"
              clearable
              style="width:500px"
              @change="inputChangeValue('smsAliyunDomain',smsForm.smsAliyunDomain)"
            ></el-input>
          </el-form-item>
          <el-form-item label="腾讯云短信Key" prop="smsQcloudsKey" v-if="smsForm.smsType=='2'">
            <el-input
              v-model.trim="smsForm.smsQcloudsKey"
              placeholder="请输入腾讯云短信Key"
              clearable
              style="width:500px"
              @change="inputChangeValue('smsQcloudsKey',smsForm.smsQcloudsKey)"
            ></el-input>
          </el-form-item>
          <el-form-item label="腾讯云短信Secret" prop="smsQcloudsSecret" v-if="smsForm.smsType=='2'">
            <el-input
              v-model.trim="smsForm.smsQcloudsSecret"
              placeholder="请输入腾讯云短信Secret"
              clearable
              style="width:500px"
              @change="inputChangeValue('smsQcloudsSecret',smsForm.smsQcloudsSecret)"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="onSubmit('smsForm')"
              style="width:100px;margin-top:10px"
            >仅保存</el-button>
            <el-button
              type="primary"
              style="width:100px;margin-top:10px"
              @click="onSubmitAndRefresh('smsForm')"
            >保存并生效</el-button>
          </el-form-item>
        </el-form>

        <el-form
          ref="pushForm"
          :model="pushForm"
          :rules="rules"
          label-width="250px"
          label-position="left"
          v-loading="loading"
          v-show="activeName=='pushMessage'"
        >
          <el-form-item label="推送是否开启" prop="pushOpen">
            <el-switch
              v-model="pushForm.pushOpen"
              active-color="#ff6a00"
              inactive-color="#f5f5f5"
              @change="inputChangeValue('pushOpen',pushForm.pushOpen)"
            ></el-switch>
          </el-form-item>
          <el-form-item label="推送类型" prop="pushType">
            <el-radio
              v-model="pushForm.pushType"
              label="1"
              @change="inputChangeValue('pushType',pushForm.pushType)"
            >极光</el-radio>
          </el-form-item>
          <el-form-item label="推送扫描频率" prop="pushCron">
            <el-input
              v-model="pushForm.pushCron"
              placeholder="请输入推送扫描频率（0/10 * * * * ?）"
              clearable
              style="width:500px"
              @change="inputChangeValue('pushCron',pushForm.pushCron)"
            ></el-input>
          </el-form-item>
          <el-form-item label="失败后发送的有效期(分钟)" prop="pushValidTime">
            <el-input-number
              v-model="pushForm.pushValidTime"
              controls-position="right"
              :min="1"
              :max="43200"
              :precision="0"
              @change="inputChangeValue('pushValidTime',pushForm.pushValidTime)"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="极光推送Key" prop="pushJiguangKey">
            <el-input
              v-model.trim="pushForm.pushJiguangKey"
              placeholder="请输入极光推送Key"
              clearable
              style="width:500px"
              @change="inputChangeValue('pushJiguangKey',pushForm.pushJiguangKey)"
            ></el-input>
          </el-form-item>
          <el-form-item label="极光推送Secret" prop="pushJiguangSecret">
            <el-input
              v-model.trim="pushForm.pushJiguangSecret"
              placeholder="请输入极光推送Secret"
              clearable
              style="width:500px"
              @change="inputChangeValue('pushJiguangSecret',pushForm.pushJiguangSecret)"
            ></el-input>
          </el-form-item>
          <el-form-item label="极光推送ApnsProduction" prop="pushJiguangApnsProduction">
            <!-- <el-input
                  v-model.trim="form.pushJiguangApnsProduction"
                  placeholder="请输入极光推送ApnsProduction"
                  clearable
                  style="width:500px"
                  @change="inputChangeValue('pushJiguangApnsProduction',form.pushJiguangApnsProduction)"
            ></el-input>-->
            <el-switch
              v-model="pushForm.pushJiguangApnsProduction"
              active-color="#ff6a00"
              inactive-color="#f5f5f5"
              @change="inputChangeValue('pushJiguangApnsProduction',pushForm.pushJiguangApnsProduction)"
            ></el-switch>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="onSubmit('pushForm')"
              style="width:100px;margin-top:10px"
            >仅保存</el-button>
            <el-button
              type="primary"
              style="width:100px;margin-top:10px"
              @click="onSubmitAndRefresh('pushForm')"
            >保存并生效</el-button>
          </el-form-item>
        </el-form>

        <el-form
          ref="fileForm"
          :model="fileForm"
          :rules="rules"
          label-width="250px"
          label-position="left"
          v-loading="loading"
          v-show="activeName=='fileSave'"
        >
          <!-- <el-form-item label="OSS是否开启" prop="ossOpen" style="margin-top:10px">
                <el-switch
                  v-model="form.ossOpen"
                  name="nd.oss.open"
                  active-color="#ff6a00"
                  inactive-color="#f5f5f5"
                ></el-switch>
          </el-form-item>-->
          <el-form-item label="OSS存储类型" prop="ossType" style="margin-top:10px">
            <el-radio-group
              v-model="fileForm.ossType"
              @change="inputChangeValue('ossType',fileForm.ossType)"
            >
              <el-radio label="NORMAL">普通存储</el-radio>
              <el-radio label="MINIO">MINIO对象存储</el-radio>
              <el-radio label="TXCOS">腾讯云COS存储</el-radio>
              <el-radio label="ALIOSS" disabled>阿里云OSS存储</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="OSS端点地址"
            prop="ossEndpoint"
            v-if="ossNormalType==false&&ossMinioType==true"
          >
            <el-input
              v-model.trim="fileForm.ossEndpoint"
              autocomplete="off"
              placeholder="请输入OSS端点地址"
              clearable
              style="width:500px"
              @change="inputChangeValue('ossEndpoint',fileForm.ossEndpoint)"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="OSS访问Key"
            prop="ossAccessKey"
            v-if="ossNormalType==false&&ossMinioType==true"
          >
            <el-input
              v-model.trim="fileForm.ossAccessKey"
              autocomplete="off"
              placeholder="请输入OSS访问Key"
              clearable
              style="width:500px"
              @change="inputChangeValue('ossAccessKey',fileForm.ossAccessKey)"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="OSS访问Secret"
            prop="ossAccessSecret"
            v-if="ossNormalType==false&&ossMinioType==true"
          >
            <el-input
              v-model.trim="fileForm.ossAccessSecret"
              placeholder="请输入OSS访问Secret"
              clearable
              style="width:500px"
              @change="inputChangeValue('ossAccessSecret',fileForm.ossAccessSecret)"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="OSS默认的存储桶名称"
            prop="ossDefaultBucketName"
            v-if="ossNormalType==false&&ossMinioType==true"
          >
            <el-input
              v-model.trim="fileForm.ossDefaultBucketName"
              placeholder="请输入OSS默认的存储桶名称"
              clearable
              style="width:500px"
              @change="inputChangeValue('ossDefaultBucketName',fileForm.ossDefaultBucketName)"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="腾讯云cos地址"
            prop="ossTxcosEndpoint"
            v-if="ossNormalType==false&&ossTxType==true"
          >
            <el-input
              v-model.trim="fileForm.ossTxcosEndpoint"
              placeholder="请输入腾讯云cos地址"
              clearable
              style="width:500px"
              @change="inputChangeValue('ossTxcosEndpoint',fileForm.ossTxcosEndpoint)"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="腾讯云cosAccessKey"
            prop="ossTxcosAccessKey"
            v-if="ossNormalType==false&&ossTxType==true"
          >
            <el-input
              v-model.trim="fileForm.ossTxcosAccessKey"
              placeholder="请输入腾讯云cosAccessKey"
              clearable
              style="width:500px"
              @change="inputChangeValue('ossTxcosAccessKey',fileForm.ossTxcosAccessKey)"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="腾讯云cos访问Secret"
            prop="ossTxcosAccessSecret"
            v-if="ossNormalType==false&&ossTxType==true"
          >
            <el-input
              v-model.trim="fileForm.ossTxcosAccessSecret"
              placeholder="请输入腾讯云cos访问Secret"
              clearable
              style="width:500px"
              @change="inputChangeValue('ossTxcosAccessSecret',fileForm.ossTxcosAccessSecret)"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="腾讯云cos区域"
            prop="ossTxcosRegion"
            v-if="ossNormalType==false&&ossTxType==true"
          >
            <el-input
              v-model.trim="fileForm.ossTxcosRegion"
              placeholder="请输入腾讯云cos区域"
              clearable
              style="width:500px"
              @change="inputChangeValue('ossTxcosRegion',fileForm.ossTxcosRegion)"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="腾讯云cos默认的存储桶名称"
            prop="ossTxcosDefaultBucketName"
            v-if="ossNormalType==false&&ossTxType==true"
          >
            <el-input
              v-model.trim="fileForm.ossTxcosDefaultBucketName"
              placeholder="请输入腾讯云cos默认的存储桶名称"
              clearable
              style="width:500px"
              @change="inputChangeValue('ossTxcosDefaultBucketName',fileForm.ossTxcosDefaultBucketName)"
            ></el-input>
          </el-form-item>
          <el-form-item label="原生文件存储的上传路径" prop="fileUploadPath" v-if="ossNormalType==true">
            <el-input
              v-model.trim="fileForm.fileUploadPath"
              placeholder="请输入原生文件存储的上传路径"
              clearable
              style="width:500px"
              @change="inputChangeValue('fileUploadPath',fileForm.fileUploadPath)"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="onSubmit('fileForm')"
              style="width:100px;margin-top:10px"
            >仅保存</el-button>
            <el-button
              type="primary"
              style="width:100px;margin-top:10px"
              @click="onSubmitAndRefresh('fileForm')"
            >保存并生效</el-button>
          </el-form-item>
        </el-form>

        <el-form
          ref="wxForm"
          :model="wxForm"
          :rules="rules"
          label-width="250px"
          label-position="left"
          v-loading="loading"
          v-show="activeName=='wechat'"
        >
          <el-form-item label="微信小程序AppId" prop="wxMpAppId" style="margin-top:10px">
            <el-input
              v-model.trim="wxForm.wxMpAppId"
              autocomplete="off"
              placeholder="请输入微信小程序AppId"
              clearable
              style="width:500px"
              @change="inputChangeValue('wxMpAppId',wxForm.wxMpAppId)"
            ></el-input>
          </el-form-item>
          <el-form-item label="微信小程序Secret" prop="wxMpSecret">
            <el-input
              v-model.trim="wxForm.wxMpSecret"
              autocomplete="off"
              placeholder="请输入微信小程序Secret"
              clearable
              style="width:500px"
              @change="inputChangeValue('wxMpSecret',wxForm.wxMpSecret)"
            ></el-input>
          </el-form-item>
          <el-form-item label="微信小程序登录API" prop="wxMpLoginApi">
            <el-input
              v-model.trim="wxForm.wxMpLoginApi"
              placeholder="请输入微信小程序登录API"
              clearable
              style="width:500px"
              @change="inputChangeValue('wxMpLoginApi',wxForm.wxMpLoginApi)"
            ></el-input>
          </el-form-item>
          <el-form-item label="微信tokenAPI" prop="wxMpTokenApi">
            <el-input
              v-model.trim="wxForm.wxMpTokenApi"
              placeholder="请输入微信tokenAPI"
              clearable
              style="width:500px"
              @change="inputChangeValue('wxMpTokenApi',wxForm.wxMpTokenApi)"
            ></el-input>
          </el-form-item>
          <el-form-item label="微信小程序二维码API" prop="wxMpQrCodeApi">
            <el-input
              v-model.trim="wxForm.wxMpQrCodeApi"
              placeholder="请输入微信小程序二维码API"
              clearable
              style="width:500px"
              @change="inputChangeValue('wxMpQrCodeApi',wxForm.wxMpQrCodeApi)"
            ></el-input>
          </el-form-item>
          <el-form-item label="企业微信AppId" prop="wxQyAppId">
            <el-input
              v-model.trim="wxForm.wxQyAppId"
              placeholder="请输入企业微信AppId"
              clearable
              style="width:500px"
              @change="inputChangeValue('wxQyAppId',wxForm.wxQyAppId)"
            ></el-input>
          </el-form-item>
          <el-form-item label="企业微信应用的AgentId" prop="wxQyAgentId">
            <el-input
              v-model.trim="wxForm.wxQyAgentId"
              placeholder="请输入企业微信应用的AgentId"
              clearable
              style="width:500px"
              @change="inputChangeValue('wxQyAgentId',wxForm.wxQyAgentId)"
            ></el-input>
          </el-form-item>
          <el-form-item label="企业微信应用的corpsecret" prop="wxQyCorpsecret">
            <el-input
              v-model.trim="wxForm.wxQyCorpsecret"
              placeholder="请输入企业微信应用的corpsecret"
              clearable
              style="width:500px"
              @change="inputChangeValue('wxQyCorpsecret',wxForm.wxQyCorpsecret)"
            ></el-input>
          </el-form-item>
          <el-form-item label="企业微信api地址" prop="wxQyApi">
            <el-input
              v-model.trim="wxForm.wxQyApi"
              placeholder="请输入企业微信api地址"
              clearable
              style="width:500px"
              @change="inputChangeValue('wxQyApi',wxForm.wxQyApi)"
            ></el-input>
          </el-form-item>
          <el-form-item label="企业微信登录回调uri" prop="wxQyRedirectUri">
            <el-input
              v-model.trim="wxForm.wxQyRedirectUri"
              placeholder="请输入企业微信登录回调uri"
              clearable
              style="width:500px"
              @change="inputChangeValue('wxQyRedirectUri',wxForm.wxQyRedirectUri)"
            ></el-input>
            <span style="color:red">企业微信登录回调uri需要使用UrlEncode编码</span>
          </el-form-item>
          <el-form-item label="企业微信同步组织/人员" prop="wxQySyncOpen">
            <el-switch
              v-model="wxForm.wxQySyncOpen"
              active-color="#ff6a00"
              inactive-color="#f5f5f5"
              @change="inputChangeValue('wxQySyncOpen',wxForm.wxQySyncOpen)"
            ></el-switch>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="onSubmit('wxForm')"
              style="width:100px;margin-top:10px"
            >仅保存</el-button>
            <el-button
              type="primary"
              style="width:100px;margin-top:10px"
              @click="onSubmitAndRefresh('wxForm')"
            >保存并生效</el-button>
          </el-form-item>
        </el-form>

        <el-form
          ref="safeForm"
          :model="safeForm"
          :rules="rules"
          label-width="250px"
          label-position="left"
          v-loading="loading"
          v-show="activeName=='safeManage'"
        >
          <el-form-item label="web端过期时间(分钟)" prop="jwtTokenExpire" style="margin-top:10px">
            <el-input-number
              v-model="safeForm.jwtTokenExpire"
              controls-position="right"
              :min="1"
              :max="43200"
              :precision="0"
              @change="inputChangeValue('jwtTokenExpire',safeForm.jwtTokenExpire)"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="app端过期时间(分钟)" prop="jwtTokenAppExpire">
            <el-input-number
              v-model="safeForm.jwtTokenAppExpire"
              controls-position="right"
              :min="1"
              :max="43200"
              :precision="0"
              @change="inputChangeValue('jwtTokenAppExpire',safeForm.jwtTokenAppExpire)"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="web端过期刷新时间(分钟)" prop="jwtTokenExpireRefresh">
            <el-input-number
              v-model="safeForm.jwtTokenExpireRefresh"
              controls-position="right"
              :min="5"
              :max="43200"
              :precision="0"
              @change="inputChangeValue('jwtTokenExpireRefresh',safeForm.jwtTokenExpireRefresh)"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="app端过期刷新时间(分钟)" prop="jwtTokenAppExpireRefresh">
            <el-input-number
              v-model="safeForm.jwtTokenAppExpireRefresh"
              controls-position="right"
              :min="1"
              :max="43200"
              :precision="0"
              @change="inputChangeValue('jwtTokenAppExpireRefresh',safeForm.jwtTokenAppExpireRefresh)"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="黑名单时间(分钟)" prop="jwtTokenExpireBacklist">
            <el-input-number
              v-model="safeForm.jwtTokenExpireBacklist"
              controls-position="right"
              :min="2"
              :max="43200"
              :precision="0"
              @change="inputChangeValue('jwtTokenExpireBacklist',safeForm.jwtTokenExpireBacklist)"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="登录认证" prop="authLoginType">
            <el-radio-group
              v-model="safeForm.authLoginType"
              @change="inputChangeValue('authLoginType',safeForm.authLoginType)"
            >
              <el-radio label="1">帐号密码</el-radio>
              <el-radio label="2">帐号密码+图形验证码</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="第三方登录(暂只支持企业微信)" prop="authThirdLoginOpen">
            <el-switch
              v-model="safeForm.authThirdLoginOpen"
              active-color="#ff6a00"
              inactive-color="#f5f5f5"
              @change="inputChangeValue('authThirdLoginOpen',safeForm.authThirdLoginOpen)"
            ></el-switch>
          </el-form-item>
          <el-form-item label="访问白名单Url" prop="authAccessWhites">
            <el-input
              type="textarea"
              v-model.trim="safeForm.authAccessWhites"
              placeholder="请输入访问白名单Url"
              clearable
              rows="10"
              style="width:500px;font-size:16px"
              @change="inputChangeValue('authAccessWhites',safeForm.authAccessWhites)"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="onSubmit('safeForm')"
              style="width:100px;margin-top:10px"
            >仅保存</el-button>
            <el-button
              type="primary"
              style="width:100px;margin-top:10px"
              @click="onSubmitAndRefresh('safeForm')"
            >保存并生效</el-button>
          </el-form-item>
        </el-form>

        <el-form
          ref="mailForm"
          :model="mailForm"
          :rules="rules"
          label-width="250px"
          label-position="left"
          v-loading="loading"
          v-show="activeName=='mailConfig'"
        >
          <el-form-item label="是否开启邮件发送" prop="mailOpen" style="margin-top:10px">
            <el-switch
              v-model="mailForm.mailOpen"
              active-color="#ff6a00"
              inactive-color="#f5f5f5"
              @change="inputChangeValue('mailOpen',mailForm.mailOpen)"
            ></el-switch>
          </el-form-item>
          <el-form-item label="是否启用SSL" prop="mailSslEnable" style="margin-top:10px">
            <el-switch
              v-model="mailForm.mailSslEnable"
              active-color="#ff6a00"
              inactive-color="#f5f5f5"
              @change="inputChangeValue('mailSslEnable',mailForm.mailSslEnable)"
            ></el-switch>
          </el-form-item>
          <el-form-item label="邮箱host" prop="mailHost">
            <el-input
              v-model.trim="mailForm.mailHost"
              autocomplete="off"
              placeholder="请输入邮箱host"
              clearable
              style="width:500px"
              @change="inputChangeValue('mailHost',mailForm.mailHost)"
            ></el-input>
          </el-form-item>
          <el-form-item label="邮箱port" prop="mailPort">
            <el-input
              v-model.trim="mailForm.mailPort"
              autocomplete="off"
              placeholder="请输入邮箱port"
              clearable
              style="width:500px"
              @change="inputChangeValue('mailPort',mailForm.mailPort)"
            ></el-input>
          </el-form-item>
          <el-form-item label="发送邮件的邮箱地址" prop="mailUser">
            <el-input
              v-model.trim="mailForm.mailUser"
              placeholder="请输入发送邮箱的邮件地址"
              clearable
              style="width:500px"
              @change="inputChangeValue('mailUser',mailForm.mailUser)"
            ></el-input>
          </el-form-item>
          <el-form-item label="邮箱发送的密码" prop="mailPassword">
            <el-input
              v-model.trim="mailForm.mailPassword"
              placeholder="请输入邮箱发送的密码"
              clearable
              style="width:500px"
              @change="inputChangeValue('mailPassword',mailForm.mailPassword)"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="onSubmit('mailForm')"
              style="width:100px;margin-top:10px"
            >仅保存</el-button>
            <el-button
              type="primary"
              style="width:100px;margin-top:10px"
              @click="onSubmitAndRefresh('mailForm')"
            >保存并生效</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import TabResize from "@/utils/TabResize.js";
import SettingApi from "@/api/setting.js";
export default {
  mixins: [TabResize],
  components: {},
  mounted: function() {
    this.activeName = "systemConfig";
    this.fileForm.ossType = "NORMAL";
    this.judgeStatus();
    this.initData();
  },
  data() {
    return {
      loading: false,
      activeName: "",
      ossNormalType: false,
      ossMinioType: false,
      ossTxType: false,
      ossAliType: false,
      systemForm: {
        sysName: "",
        sysVersion: "",
        sysCopyright: "",
        sysIcp: ""
      },
      smsForm: {
        smsOpen: false,
        smsType: "1",
        smsCron: "",
        smsRetrySendTimes: 1,
        smsAliyunKey: "",
        smsAliyunSecret: "",
        smsAliyunDomain: "",
        smsQcloudsKey: "",
        smsQcloudsSecret: ""
      },
      pushForm: {
        pushCron: "",
        pushOpen: false,
        pushType: "1",
        pushValidTime: 1,
        pushJiguangKey: "",
        pushJiguangSecret: "",
        pushJiguangApnsProduction: ""
      },
      fileForm: {
        // ossOpen: false,
        ossEndpoint: "",
        ossAccessKey: "",
        ossAccessSecret: "",
        ossDefaultBucketName: "",
        //默认值
        ossType: "NORMAL",
        ossTxcosEndpoint: "",
        ossTxcosAccessKey: "",
        ossTxcosAccessSecret: "",
        ossTxcosRegion: "",
        ossTxcosDefaultBucketName: "",
        fileUploadPath: "",
        fileUploadTempPath: ""
      },
      wxForm: {
        wxMpAppId: "",
        wxMpSecret: "",
        wxMpLoginApi: "",
        wxMpTokenApi: "",
        wxMpQrCodeApi: "",
        wxQyAppId: "",
        wxQyAgentId: "",
        wxQyCorpsecret: "",
        wxQySyncOpen: false,
        wxQyApi: "",
        wxQyRedirectUri: ""
      },
      safeForm: {
        jwtTokenExpire: 5,
        jwtTokenAppExpire: 5,
        jwtTokenExpireRefresh: 5,
        jwtTokenAppExpireRefresh: 5,
        jwtTokenExpireBacklist: 2,
        authLoginType: "1",
        authThirdLoginOpen: false,
        authAccessWhites: ""
      },
      mailForm: {
        mailOpen: false,
        mailSslEnable: true,
        mailHost: "",
        mailPort: "",
        mailUser: "",
        mailPassword: ""
      },
      rules: {
        sysName: [
          {
            required: true,
            message: "系统名称不能为空",
            trigger: "blur"
          },
          {
            max: 100,
            message: "系统名称不能超过100个字符，请重新输入",
            trigger: "blur"
          }
        ],
        sysVersion: [
          {
            required: false,
            message: "系统版本不能为空",
            trigger: "blur"
          },
          {
            max: 100,
            message: "系统版本不能超过100个字符，请重新输入",
            trigger: "blur"
          }
        ],
        sysCopyright: [
          {
            required: false,
            message: "版权信息不能为空",
            trigger: "blur"
          },
          {
            max: 100,
            message: "版权信息不能超过100个字符，请重新输入",
            trigger: "blur"
          }
        ],
        sysIcp: [
          {
            required: false,
            message: "icp备案号不能为空",
            trigger: "blur"
          },
          {
            max: 100,
            message: "icp备案号不能超过100个字符，请重新输入",
            trigger: "blur"
          }
        ],
        smsCron: [
          {
            required: false,
            message: "消息扫描频率不能为空",
            trigger: "blur"
          },
          {
            max: 100,
            message: "消息扫描频率不能超过100个字符，请重新输入",
            trigger: "blur"
          }
        ],
        smsAliyunKey: [
          {
            required: false,
            message: "阿里云短信Key不能为空",
            trigger: "blur"
          },
          {
            max: 150,
            message: "阿里云短信Key不能超过150个字符，请重新输入",
            trigger: "blur"
          }
        ],
        smsAliyunSecret: [
          {
            required: false,
            message: "阿里云短信Secret不能为空",
            trigger: "blur"
          },
          {
            max: 150,
            message: "阿里云短信Secret不能超过150个字符，请重新输入",
            trigger: "blur"
          }
        ],
        smsAliyunDomain: [
          {
            required: false,
            message: "阿里云短信Domain不能为空",
            trigger: "blur"
          },
          {
            max: 150,
            message: "阿里云短信Domain不能超过150个字符，请重新输入",
            trigger: "blur"
          }
        ],
        smsRetrySendTimes: [
          {
            required: false,
            message: "失效重发有效期不能为空",
            trigger: "blur"
          }
        ],
        smsQcloudsKey: [
          {
            required: false,
            message: "腾讯云短信Key不能为空",
            trigger: "blur"
          },
          {
            max: 150,
            message: "腾讯云短信Key不能超过150个字符，请重新输入",
            trigger: "blur"
          }
        ],
        smsQcloudsSecret: [
          {
            required: false,
            message: "腾讯云短信Secret不能为空",
            trigger: "blur"
          },
          {
            max: 150,
            message: "腾讯云短信Secret不能超过150个字符，请重新输入",
            trigger: "blur"
          }
        ],
        pushCron: [
          {
            required: false,
            message: "推送扫描频率不能为空",
            trigger: "blur"
          },
          {
            max: 100,
            message: "推送扫描频率不能超过100个字符，请重新输入",
            trigger: "blur"
          }
        ],
        pushValidTime: [
          {
            required: false,
            message: "失败后发送的有效期不能为空",
            trigger: "blur"
          }
        ],
        pushJiguangKey: [
          {
            required: false,
            message: "极光推送Key不能为空",
            trigger: "blur"
          },
          {
            max: 150,
            message: "极光推送Key不能超过150个字符，请重新输入",
            trigger: "blur"
          }
        ],
        pushJiguangSecret: [
          {
            required: false,
            message: "极光推送Secret不能为空",
            trigger: "blur"
          },
          {
            max: 150,
            message: "极光推送Secret不能超过150个字符，请重新输入",
            trigger: "blur"
          }
        ],
        pushJiguangApnsProduction: [
          {
            required: false,
            message: "极光推送ApnsProduction不能为空",
            trigger: "blur"
          }
        ],
        ossEndpoint: [
          {
            required: true,
            message: "OSS端点地址不能为空",
            trigger: "blur"
          },
          {
            max: 150,
            message: "OSS端点地址输入不能超过150个字符，请重新输入",
            trigger: "blur"
          }
        ],
        ossAccessKey: [
          {
            required: true,
            message: "OSS访问Key不能为空",
            trigger: "blur"
          },
          {
            max: 150,
            message: "OSS访问Key输入不能超过150个字符，请重新输入",
            trigger: "blur"
          }
        ],
        ossAccessSecret: [
          {
            required: true,
            message: "OSS访问Secret不能为空",
            trigger: "blur"
          },
          {
            max: 150,
            message: "OSS访问Secret输入不能超过150个字符，请重新输入",
            trigger: "blur"
          }
        ],
        ossDefaultBucketName: [
          {
            required: true,
            message: "OSS默认的存储桶名称不能为空",
            trigger: "blur"
          },
          {
            max: 150,
            message: "OSS默认的存储桶名称输入不能超过150个字符，请重新输入",
            trigger: "blur"
          }
        ],
        ossTxcosEndpoint: [
          {
            required: true,
            message: "腾讯云cos地址不能为空",
            trigger: "blur"
          },
          {
            max: 150,
            message: "腾讯云cos地址输入不能超过150个字符，请重新输入",
            trigger: "blur"
          }
        ],
        ossTxcosAccessKey: [
          {
            required: true,
            message: "腾讯云cosAccessKey不能为空",
            trigger: "blur"
          },
          {
            max: 150,
            message: "腾讯云cosAccessKey输入不能超过150个字符，请重新输入",
            trigger: "blur"
          }
        ],
        ossTxcosAccessSecret: [
          {
            required: true,
            message: "腾讯云cos访问Secret不能为空",
            trigger: "blur"
          },
          {
            max: 150,
            message: "腾讯云cos访问Secret输入不能超过150个字符，请重新输入",
            trigger: "blur"
          }
        ],
        ossTxcosRegion: [
          {
            required: true,
            message: "腾讯云cos区域不能为空",
            trigger: "blur"
          },
          {
            max: 150,
            message: "腾讯云cos区域输入不能超过150个字符，请重新输入",
            trigger: "blur"
          }
        ],
        ossTxcosDefaultBucketName: [
          {
            required: true,
            message: "腾讯云cos默认的存储桶名称不能为空",
            trigger: "blur"
          },
          {
            max: 150,
            message:
              "腾讯云cos默认的存储桶名称输入不能超过150个字符，请重新输入",
            trigger: "blur"
          }
        ],
        fileUploadPath: [
          {
            required: true,
            message: "原生文件存储的上传路径不能为空",
            trigger: "blur"
          },
          {
            max: 150,
            message: "原生文件存储的上传路径输入不能超过150个字符，请重新输入",
            trigger: "blur"
          }
        ],
        wxMpAppId: [
          {
            required: false,
            message: "微信小程序AppId不能为空",
            trigger: "blur"
          },
          {
            max: 150,
            message: "微信小程序AppId输入不能超过150个字符，请重新输入",
            trigger: "blur"
          }
        ],
        wxMpSecret: [
          {
            required: false,
            message: "微信小程序Secret不能为空",
            trigger: "blur"
          },
          {
            max: 150,
            message: "微信小程序Secret输入不能超过150个字符，请重新输入",
            trigger: "blur"
          }
        ],
        wxMpLoginApi: [
          {
            required: false,
            message: "微信小程序登录API不能为空",
            trigger: "blur"
          },
          {
            max: 500,
            message: "微信小程序登录API输入不能超过500个字符，请重新输入",
            trigger: "blur"
          }
        ],
        wxMpTokenApi: [
          {
            required: false,
            message: "微信tokenAPI不能为空",
            trigger: "blur"
          },
          {
            max: 500,
            message: "微信tokenAPI输入不能超过500个字符，请重新输入",
            trigger: "blur"
          }
        ],
        wxMpQrCodeApi: [
          {
            required: false,
            message: "微信小程序二维码API不能为空",
            trigger: "blur"
          },
          {
            max: 500,
            message: "微信小程序二维码API输入不能超过500个字符，请重新输入",
            trigger: "blur"
          }
        ],
        wxQyAppId: [
          {
            required: false,
            message: "企业微信AppId不能为空",
            trigger: "blur"
          },
          {
            max: 150,
            message: "企业微信AppId输入不能超过150个字符，请重新输入",
            trigger: "blur"
          }
        ],
        wxQyAgentId: [
          {
            required: false,
            message: "企业微信应用的AgentId不能为空",
            trigger: "blur"
          },
          {
            max: 150,
            message: "企业微信应用的AgentId输入不能超过150个字符，请重新输入",
            trigger: "blur"
          }
        ],
        wxQyCorpsecret: [
          {
            required: false,
            message: "企业微信应用的corpsecret不能为空",
            trigger: "blur"
          },
          {
            max: 150,
            message:
              "企业微信应用的corpsecret输入不能超过150个字符，请重新输入",
            trigger: "blur"
          }
        ],
        wxQyApi: [
          {
            required: false,
            message: "企业微信api地址不能为空",
            trigger: "blur"
          },
          {
            max: 500,
            message: "企业微信api地址输入不能超过500个字符，请重新输入",
            trigger: "blur"
          }
        ],
        wxQyRedirectUri: [
          {
            required: false,
            message: "企业微信登录回调uri不能为空",
            trigger: "blur"
          },
          {
            max: 500,
            message: "企业微信登录回调uri输入不能超过500个字符，请重新输入",
            trigger: "blur"
          }
        ],
        jwtTokenExpire: [
          {
            required: true,
            message: "web端过期时间不能为空",
            trigger: "blur"
          }
        ],
        jwtTokenAppExpire: [
          {
            required: true,
            message: "app端过期时间不能为空",
            trigger: "blur"
          }
        ],
        jwtTokenExpireRefresh: [
          {
            required: true,
            message: "web端过期刷新时间不能为空",
            trigger: "blur"
          }
        ],
        jwtTokenAppExpireRefresh: [
          {
            required: true,
            message: "app端过期刷新时间不能为空",
            trigger: "blur"
          }
        ],
        jwtTokenExpireBacklist: [
          {
            required: true,
            message: "黑名单时间不能为空",
            trigger: "blur"
          }
        ],
        authAccessWhites: [
          {
            required: true,
            message: "访问白名单Url不能为空",
            trigger: "blur"
          },
          {
            max: 3000,
            message: "访问白名单Url输入不能超过3000个字符，请重新输入",
            trigger: "blur"
          }
        ],
        mailHost: [
          {
            required: true,
            message: "邮箱服务器不能为空",
            trigger: "blur"
          },
          {
            max: 100,
            message: "邮箱服务器输入不能超过100个字符，请重新输入",
            trigger: "blur"
          }
        ],
        mailPort: [
          {
            required: true,
            message: "邮箱端口不能为空",
            trigger: "blur"
          },
          {
            max: 20,
            message: "邮箱端口输入不能超过20个字符，请重新输入",
            trigger: "blur"
          },
          {
            pattern: /^[0-9]*$/,
            message: "邮箱端口只能输入数字"
          }
        ],
        mailUser: [
          {
            required: true,
            message: "发送邮箱的邮件地址不能为空",
            trigger: "blur"
          },
          {
            max: 100,
            message: "发送邮箱的邮件地址输入不能超过100个字符，请重新输入",
            trigger: "blur"
          },
          {
            validator: function(rule, value, callback) {
              if (value != null && value != "") {
                if (
                  /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(
                    value
                  ) == false
                ) {
                  callback(new Error("请输入有效的邮箱地址"));
                } else {
                  callback();
                }
              } else {
                return callback();
              }
            }
          }
        ],
        mailPassword: [
          {
            required: true,
            message: "邮箱发送的密码不能为空",
            trigger: "blur"
          },
          {
            max: 50,
            message: "邮箱发送的密码输入不能超过50个字符，请重新输入",
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    handleClick(tab, event) {
      // this.$refs["form"].clearValidate();
    },
    initData() {
      this.loading = true;
      let param = {};
      SettingApi.getClass()
        .getProductList(param)
        .then(res2 => {
          if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
            let data = res2.data.data;
            for (let i = 0; i < data.length; i++) {
              if (data[i].name == "sysName") {
                this.systemForm.sysName = data[i].confVal;
                this.systemForm.sysNameId = data[i].id;
                continue;
              }
              if (data[i].name == "sysVersion") {
                this.systemForm.sysVersion = data[i].confVal;
                this.systemForm.sysVersionId = data[i].id;
                continue;
              }
              if (data[i].name == "sysCopyright") {
                this.systemForm.sysCopyright = data[i].confVal;
                this.systemForm.sysCopyrightId = data[i].id;
                continue;
              }
              if (data[i].name == "sysIcp") {
                this.systemForm.sysIcp = data[i].confVal;
                this.systemForm.sysIcpId = data[i].id;
                continue;
              }
              if (data[i].name == "smsOpen") {
                if (data[i].confVal == "true") {
                  this.smsForm.smsOpen = true;
                } else {
                  this.smsForm.smsOpen = false;
                }
                this.validSms(this.smsForm.smsOpen);
                this.smsForm.smsOpenId = data[i].id;
                continue;
              }
              if (data[i].name == "smsType") {
                this.smsForm.smsType = data[i].confVal;
                this.smsForm.smsTypeId = data[i].id;
                continue;
              }
              if (data[i].name == "smsCron") {
                this.smsForm.smsCron = data[i].confVal;
                this.smsForm.smsCronId = data[i].id;
                continue;
              }
              if (data[i].name == "smsRetrySendTimes") {
                this.smsForm.smsRetrySendTimes = data[i].confVal;
                this.smsForm.smsRetrySendTimesId = data[i].id;
                continue;
              }
              if (data[i].name == "smsAliyunKey") {
                this.smsForm.smsAliyunKey = data[i].confVal;
                this.smsForm.smsAliyunKeyId = data[i].id;
                continue;
              }
              if (data[i].name == "smsAliyunSecret") {
                this.smsForm.smsAliyunSecret = data[i].confVal;
                this.smsForm.smsAliyunSecretId = data[i].id;
                continue;
              }
              if (data[i].name == "smsAliyunDomain") {
                this.smsForm.smsAliyunDomain = data[i].confVal;
                this.smsForm.smsAliyunDomainId = data[i].id;
                continue;
              }
              if (data[i].name == "smsQcloudsKey") {
                this.smsForm.smsQcloudsKey = data[i].confVal;
                this.smsForm.smsQcloudsKeyId = data[i].id;
                continue;
              }
              if (data[i].name == "smsQcloudsSecret") {
                this.smsForm.smsQcloudsSecret = data[i].confVal;
                this.smsForm.smsQcloudsSecretId = data[i].id;
                continue;
              }
              if (data[i].name == "pushCron") {
                this.pushForm.pushCron = data[i].confVal;
                this.pushForm.pushCronId = data[i].id;
                continue;
              }
              if (data[i].name == "pushOpen") {
                if (data[i].confVal == "true") {
                  this.pushForm.pushOpen = true;
                } else {
                  this.pushForm.pushOpen = false;
                }
                this.validPush(this.pushForm.pushOpen);
                this.pushForm.pushOpenId = data[i].id;
                continue;
              }
              if (data[i].name == "pushType") {
                this.pushForm.pushType = data[i].confVal;
                this.pushForm.pushTypeId = data[i].id;
                continue;
              }
              if (data[i].name == "pushValidTime") {
                this.pushForm.pushValidTime = data[i].confVal;
                this.pushForm.pushValidTimeId = data[i].id;
                continue;
              }
              if (data[i].name == "pushJiguangKey") {
                this.pushForm.pushJiguangKey = data[i].confVal;
                this.pushForm.pushJiguangKeyId = data[i].id;
                continue;
              }
              if (data[i].name == "pushJiguangSecret") {
                this.pushForm.pushJiguangSecret = data[i].confVal;
                this.pushForm.pushJiguangSecretId = data[i].id;
                continue;
              }
              if (data[i].name == "pushJiguangApnsProduction") {
                if (data[i].confVal == "true") {
                  this.pushForm.pushJiguangApnsProduction = true;
                } else {
                  this.pushForm.pushJiguangApnsProduction = false;
                }
                this.pushForm.pushJiguangApnsProductionId = data[i].id;
                continue;
              }
              // if (data[i].name == "ossOpen") {
              //   if (data[i].confVal == "true") {
              //     this.form.ossOpen = true;
              //   } else {
              //     this.form.ossOpen = false;
              //   }
              //   this.form.ossOpenId = data[i].id;
              //   continue;
              // }
              //新增oss腾讯存储
              if (data[i].name == "ossType") {
                this.fileForm.ossType = data[i].confVal;
                this.fileForm.ossTypeId = data[i].id;
                this.judgeStatus();
                continue;
              }
              if (data[i].name == "ossTxcosEndpoint") {
                this.fileForm.ossTxcosEndpoint = data[i].confVal;
                this.fileForm.ossTxcosEndpointId = data[i].id;
                continue;
              }
              if (data[i].name == "ossTxcosAccessKey") {
                this.fileForm.ossTxcosAccessKey = data[i].confVal;
                this.fileForm.ossTxcosAccessKeyId = data[i].id;
                continue;
              }
              if (data[i].name == "ossTxcosAccessSecret") {
                this.fileForm.ossTxcosAccessSecret = data[i].confVal;
                this.fileForm.ossTxcosAccessSecretId = data[i].id;
                continue;
              }
              if (data[i].name == "ossTxcosRegion") {
                this.fileForm.ossTxcosRegion = data[i].confVal;
                this.fileForm.ossTxcosRegionId = data[i].id;
                continue;
              }
              if (data[i].name == "ossTxcosDefaultBucketName") {
                this.fileForm.ossTxcosDefaultBucketName = data[i].confVal;
                this.fileForm.ossTxcosDefaultBucketNameId = data[i].id;
                continue;
              }
              if (data[i].name == "ossEndpoint") {
                this.fileForm.ossEndpoint = data[i].confVal;
                this.fileForm.ossEndpointId = data[i].id;
                continue;
              }
              if (data[i].name == "ossAccessKey") {
                this.fileForm.ossAccessKey = data[i].confVal;
                this.fileForm.ossAccessKeyId = data[i].id;
                continue;
              }
              if (data[i].name == "ossAccessSecret") {
                this.fileForm.ossAccessSecret = data[i].confVal;
                this.fileForm.ossAccessSecretId = data[i].id;
                continue;
              }
              if (data[i].name == "ossDefaultBucketName") {
                this.fileForm.ossDefaultBucketName = data[i].confVal;
                this.fileForm.ossDefaultBucketNameId = data[i].id;
                continue;
              }
              if (data[i].name == "fileUploadPath") {
                this.fileForm.fileUploadPath = data[i].confVal;
                this.fileForm.fileUploadPathId = data[i].id;
                continue;
              }
              if (data[i].name == "fileUploadTempPath") {
                this.fileForm.fileUploadTempPath = data[i].confVal;
                this.fileForm.fileUploadTempPathId = data[i].id;
                continue;
              }
              if (data[i].name == "wxMpAppId") {
                this.wxForm.wxMpAppId = data[i].confVal;
                this.wxForm.wxMpAppIdId = data[i].id;
                continue;
              }
              if (data[i].name == "wxMpSecret") {
                this.wxForm.wxMpSecret = data[i].confVal;
                this.wxForm.wxMpSecretId = data[i].id;
                continue;
              }
              if (data[i].name == "wxMpLoginApi") {
                this.wxForm.wxMpLoginApi = data[i].confVal;
                this.wxForm.wxMpLoginApiId = data[i].id;
                continue;
              }
              if (data[i].name == "wxMpTokenApi") {
                this.wxForm.wxMpTokenApi = data[i].confVal;
                this.wxForm.wxMpTokenApiId = data[i].id;
                continue;
              }
              if (data[i].name == "wxMpQrCodeApi") {
                this.wxForm.wxMpQrCodeApi = data[i].confVal;
                this.wxForm.wxMpQrCodeApiId = data[i].id;
                continue;
              }
              if (data[i].name == "wxQyAppId") {
                this.wxForm.wxQyAppId = data[i].confVal;
                this.wxForm.wxQyAppIdId = data[i].id;
                continue;
              }
              if (data[i].name == "wxQyAgentId") {
                this.wxForm.wxQyAgentId = data[i].confVal;
                this.wxForm.wxQyAgentIdId = data[i].id;
                continue;
              }
              if (data[i].name == "wxQyCorpsecret") {
                this.wxForm.wxQyCorpsecret = data[i].confVal;
                this.wxForm.wxQyCorpsecretId = data[i].id;
                continue;
              }
              if (data[i].name == "wxQyApi") {
                this.wxForm.wxQyApi = data[i].confVal;
                this.wxForm.wxQyApiId = data[i].id;
                continue;
              }
              if (data[i].name == "wxQyRedirectUri") {
                this.wxForm.wxQyRedirectUri = data[i].confVal;
                this.wxForm.wxQyRedirectUriId = data[i].id;
                continue;
              }
              if (data[i].name == "wxQySyncOpen") {
                if (data[i].confVal == "true") {
                  this.wxForm.wxQySyncOpen = true;
                } else {
                  this.wxForm.wxQySyncOpen = false;
                }
                this.wxForm.wxQySyncOpenId = data[i].id;
                continue;
              }
              if (data[i].name == "jwtTokenExpire") {
                this.safeForm.jwtTokenExpire = data[i].confVal;
                this.safeForm.jwtTokenExpireId = data[i].id;
                continue;
              }
              if (data[i].name == "jwtTokenAppExpire") {
                this.safeForm.jwtTokenAppExpire = data[i].confVal;
                this.safeForm.jwtTokenAppExpireId = data[i].id;
                continue;
              }
              if (data[i].name == "jwtTokenExpireRefresh") {
                this.safeForm.jwtTokenExpireRefresh = data[i].confVal;
                this.safeForm.jwtTokenExpireRefreshId = data[i].id;
                continue;
              }
              if (data[i].name == "jwtTokenAppExpireRefresh") {
                this.safeForm.jwtTokenAppExpireRefresh = data[i].confVal;
                this.safeForm.jwtTokenAppExpireRefreshId = data[i].id;
                continue;
              }
              if (data[i].name == "jwtTokenExpireBacklist") {
                this.safeForm.jwtTokenExpireBacklist = data[i].confVal;
                this.safeForm.jwtTokenExpireBacklistId = data[i].id;
                continue;
              }
              if (data[i].name == "authLoginType") {
                this.safeForm.authLoginType = data[i].confVal;
                this.safeForm.authLoginTypeId = data[i].id;
                continue;
              }
              if (data[i].name == "authThirdLoginOpen") {
                if (data[i].confVal == "true") {
                  this.safeForm.authThirdLoginOpen = true;
                } else {
                  this.safeForm.authThirdLoginOpen = false;
                }
                this.safeForm.authThirdLoginOpenId = data[i].id;
                continue;
              }
              if (data[i].name == "authAccessWhites") {
                this.safeForm.authAccessWhites = data[i].confVal;
                this.safeForm.authAccessWhitesId = data[i].id;
                continue;
              }
              if (data[i].name == "mailOpen") {
                if (data[i].confVal == "true") {
                  this.mailForm.mailOpen = true;
                } else {
                  this.mailForm.mailOpen = false;
                }
                this.validMail(this.mailForm.mailOpen);
                this.mailForm.mailOpenId = data[i].id;
                continue;
              }
              if (data[i].name == "mailSslEnable") {
                if (data[i].confVal == "true") {
                  this.mailForm.mailSslEnable = true;
                } else {
                  this.mailForm.mailSslEnable = false;
                }
                this.mailForm.mailSslEnableId = data[i].id;
                continue;
              }
              if (data[i].name == "mailHost") {
                this.mailForm.mailHost = data[i].confVal;
                this.mailForm.mailHostId = data[i].id;
                continue;
              }
              if (data[i].name == "mailPort") {
                this.mailForm.mailPort = data[i].confVal;
                this.mailForm.mailPortId = data[i].id;
                continue;
              }
              if (data[i].name == "mailUser") {
                this.mailForm.mailUser = data[i].confVal;
                this.mailForm.mailUserId = data[i].id;
                continue;
              }
              if (data[i].name == "mailPassword") {
                this.mailForm.mailPassword = data[i].confVal;
                this.mailForm.mailPasswordId = data[i].id;
                continue;
              }
            }
            this.loading = false;
          } else {
            this.$message.error(res2.data.msg);
            this.loading = false;
            return false;
          }
        })
        .catch(err => {
          this.loading = false;
          this.$message.error(err);
          return false;
        });
    },
    onSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loading = true;
          let ndConfigList = [];
          if (formName == "systemForm") {
            ndConfigList = this.getSystemParam();
          } else if (formName == "smsForm") {
            ndConfigList = this.getSmsParam();
          } else if (formName == "pushForm") {
            ndConfigList = this.getPushParam();
          } else if (formName == "fileForm") {
            ndConfigList = this.getFileParam();
          } else if (formName == "wxForm") {
            ndConfigList = this.getWxParam();
          } else if (formName == "safeForm") {
            ndConfigList = this.getSafeParam();
          } else if (formName == "mailForm") {
            ndConfigList = this.getMailParam();
          }
          let param = {
            isRefresh: false,
            ndConfigList: ndConfigList
          };
          this.saveProduct(param);
        } else {
          this.loading = false;
          console.log("error submit!!");
        }
      });
    },
    onSubmitAndRefresh(formName) {
      this.$confirm("确定保存并立即生效吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$refs[formName].validate(valid => {
            if (valid) {
              this.loading = true;
              let ndConfigList = [];
              if (formName == "systemForm") {
                ndConfigList = this.getSystemParam();
              } else if (formName == "smsForm") {
                ndConfigList = this.getSmsParam();
              } else if (formName == "pushForm") {
                ndConfigList = this.getPushParam();
              } else if (formName == "fileForm") {
                ndConfigList = this.getFileParam();
              } else if (formName == "wxForm") {
                ndConfigList = this.getWxParam();
              } else if (formName == "safeForm") {
                ndConfigList = this.getSafeParam();
              } else if (formName == "mailForm") {
                ndConfigList = this.getMailParam();
              }
              let param = {
                isRefresh: true,
                ndConfigList: ndConfigList
              };
              this.saveProduct(param);
            } else {
              this.loading = false;
              console.log("error submit!!");
            }
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    saveProduct(param) {
      SettingApi.getClass()
        .saveProduct(param)
        .then(res2 => {
          if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
            this.$message.success("保存成功！");
            this.loading = false;
          } else {
            this.loading = false;
            this.$message.error(res2.data.msg);
          }
        })
        .catch(err => {
          this.loading = false;
          this.$message.error(err);
        });
    },
    getSystemParam() {
      let formList = [];
      let ndConfigList = [];
      formList.push(
        {
          confKey: "nd.sys.name",
          confVal: this.systemForm.sysName,
          id: this.systemForm.sysNameId,
          name: "sysName"
        },
        {
          confKey: "nd.sys.version",
          confVal: this.systemForm.sysVersion,
          id: this.systemForm.sysVersionId,
          name: "sysVersion"
        },
        {
          confKey: "nd.sys.copyright",
          confVal: this.systemForm.sysCopyright,
          id: this.systemForm.sysCopyrightId,
          name: "sysCopyright"
        },
        {
          confKey: "nd.sys.icp",
          confVal: this.systemForm.sysIcp,
          id: this.systemForm.sysIcpId,
          name: "sysIcp"
        }
      );
      for (let i = 0; i < formList.length; i++) {
        ndConfigList.push(formList[i]);
      }
      return ndConfigList;
    },
    getSmsParam() {
      let formList = [];
      let ndConfigList = [];
      formList.push(
        {
          confKey: "nd.sms.open",
          confVal: this.smsForm.smsOpen,
          id: this.smsForm.smsOpenId,
          name: "smsOpen"
        },
        {
          confKey: "nd.sms.smsType",
          confVal: this.smsForm.smsType,
          id: this.smsForm.smsTypeId,
          name: "smsType"
        },
        {
          confKey: "nd.sms.cron",
          confVal: this.smsForm.smsCron,
          id: this.smsForm.smsCronId,
          name: "smsCron"
        },
        {
          confKey: "nd.sms.retrySendTimes",
          confVal: this.smsForm.smsRetrySendTimes,
          id: this.smsForm.smsRetrySendTimesId,
          name: "smsRetrySendTimes"
        },
        {
          confKey: "nd.sms.aliyun.key",
          confVal: this.smsForm.smsAliyunKey,
          id: this.smsForm.smsAliyunKeyId,
          name: "smsAliyunKey"
        },
        {
          confKey: "nd.sms.aliyun.secret",
          confVal: this.smsForm.smsAliyunSecret,
          id: this.smsForm.smsAliyunSecretId,
          name: "smsAliyunSecret"
        },
        {
          confKey: "nd.sms.aliyun.domain",
          confVal: this.smsForm.smsAliyunDomain,
          id: this.smsForm.smsAliyunDomainId,
          name: "smsAliyunDomain"
        },
        {
          confKey: "nd.sms.qclouds.key",
          confVal: this.smsForm.smsQcloudsKey,
          id: this.smsForm.smsQcloudsKeyId,
          name: "smsQcloudsKey"
        },
        {
          confKey: "nd.sms.qclouds.secret",
          confVal: this.smsForm.smsQcloudsSecret,
          id: this.smsForm.smsQcloudsSecretId,
          name: "smsQcloudsSecret"
        }
      );
      for (let i = 0; i < formList.length; i++) {
        ndConfigList.push(formList[i]);
      }
      return ndConfigList;
    },
    getPushParam() {
      let formList = [];
      let ndConfigList = [];
      formList.push(
        {
          confKey: "nd.push.cron",
          confVal: this.pushForm.pushCron,
          id: this.pushForm.pushCronId,
          name: "pushCron"
        },
        {
          confKey: "nd.push.open",
          confVal: this.pushForm.pushOpen,
          id: this.pushForm.pushOpenId,
          name: "pushOpen"
        },
        {
          confKey: "nd.push.pushType",
          confVal: this.pushForm.pushType,
          id: this.pushForm.pushTypeId,
          name: "pushType"
        },
        {
          confKey: "nd.push.validTime",
          confVal: this.pushForm.pushValidTime,
          id: this.pushForm.pushValidTimeId,
          name: "pushValidTime"
        },
        {
          confKey: "nd.push.jiguang.key",
          confVal: this.pushForm.pushJiguangKey,
          id: this.pushForm.pushJiguangKeyId,
          name: "pushJiguangKey"
        },
        {
          confKey: "nd.push.jiguang.secret",
          confVal: this.pushForm.pushJiguangSecret,
          id: this.pushForm.pushJiguangSecretId,
          name: "pushJiguangSecret"
        },
        {
          confKey: "nd.push.jiguang.apnsProduction",
          confVal: this.pushForm.pushJiguangApnsProduction,
          id: this.pushForm.pushJiguangApnsProductionId,
          name: "pushJiguangApnsProduction"
        }
      );
      for (let i = 0; i < formList.length; i++) {
        ndConfigList.push(formList[i]);
      }
      return ndConfigList;
    },
    getFileParam() {
      let formList = [];
      let ndConfigList = [];
      formList.push(
        // {
        //   confKey: "nd.oss.open",
        //   confVal: v.ossOpen,
        //   id: v.ossOpenId,
        //   name: "ossOpen"
        // },
        //增加oss腾讯存储
        {
          confKey: "nd.oss.type",
          confVal: this.fileForm.ossType,
          id: this.fileForm.ossTypeId,
          name: "ossType"
        },
        {
          confKey: "nd.oss.txcos.endpoint",
          confVal: this.fileForm.ossTxcosEndpoint,
          id: this.fileForm.ossTxcosEndpointId,
          name: "ossTxcosEndpoint"
        },
        {
          confKey: "nd.oss.txcos.accessKey",
          confVal: this.fileForm.ossTxcosAccessKey,
          id: this.fileForm.ossTxcosAccessKeyId,
          name: "ossTxcosAccessKey"
        },
        {
          confKey: "nd.oss.txcos.accessSecret",
          confVal: this.fileForm.ossTxcosAccessSecret,
          id: this.fileForm.ossTxcosAccessSecretId,
          name: "ossTxcosAccessSecret"
        },
        {
          confKey: "nd.oss.txcos.region",
          confVal: this.fileForm.ossTxcosRegion,
          id: this.fileForm.ossTxcosRegionId,
          name: "ossTxcosRegion"
        },
        {
          confKey: "nd.oss.txcos.defaultBucketName",
          confVal: this.fileForm.ossTxcosDefaultBucketName,
          id: this.fileForm.ossTxcosDefaultBucketNameId,
          name: "ossTxcosDefaultBucketName"
        },
        {
          confKey: "nd.oss.endpoint",
          confVal: this.fileForm.ossEndpoint,
          id: this.fileForm.ossEndpointId,
          name: "ossEndpoint"
        },
        {
          confKey: "nd.oss.accessKey",
          confVal: this.fileForm.ossAccessKey,
          id: this.fileForm.ossAccessKeyId,
          name: "ossAccessKey"
        },
        {
          confKey: "nd.oss.accessSecret",
          confVal: this.fileForm.ossAccessSecret,
          id: this.fileForm.ossAccessSecretId,
          name: "ossAccessSecret"
        },
        {
          confKey: "nd.oss.defaultBucketName",
          confVal: this.fileForm.ossDefaultBucketName,
          id: this.fileForm.ossDefaultBucketNameId,
          name: "ossDefaultBucketName"
        },
        {
          confKey: "nd.file.uploadPath",
          confVal: this.fileForm.fileUploadPath,
          id: this.fileForm.fileUploadPathId,
          name: "fileUploadPath"
        }
        // {
        //   confKey: "nd.file.uploadTempPath",
        //   confVal: v.fileUploadTempPath,
        //   id: v.fileUploadTempPathId,
        //   name: "fileUploadTempPath"
        // },
      );
      for (let i = 0; i < formList.length; i++) {
        ndConfigList.push(formList[i]);
      }
      return ndConfigList;
    },
    getWxParam() {
      let formList = [];
      let ndConfigList = [];
      formList.push(
        {
          confKey: "nd.wx.mp.appId",
          confVal: this.wxForm.wxMpAppId,
          id: this.wxForm.wxMpAppIdId,
          name: "wxMpAppId"
        },
        {
          confKey: "nd.wx.mp.secret",
          confVal: this.wxForm.wxMpSecret,
          id: this.wxForm.wxMpSecretId,
          name: "wxMpSecret"
        },
        {
          confKey: "nd.wx.mp.loginApi",
          confVal: this.wxForm.wxMpLoginApi,
          id: this.wxForm.wxMpLoginApiId,
          name: "wxMpLoginApi"
        },
        {
          confKey: "nd.wx.mp.tokenApi",
          confVal: this.wxForm.wxMpTokenApi,
          id: this.wxForm.wxMpTokenApiId,
          name: "wxMpTokenApi"
        },
        {
          confKey: "nd.wx.mp.qrCodeApi",
          confVal: this.wxForm.wxMpQrCodeApi,
          id: this.wxForm.wxMpQrCodeApiId,
          name: "wxMpQrCodeApi"
        },
        {
          confKey: "nd.wx.qy.appId",
          confVal: this.wxForm.wxQyAppId,
          id: this.wxForm.wxQyAppIdId,
          name: "wxQyAppId"
        },
        {
          confKey: "nd.wx.qy.agentId",
          confVal: this.wxForm.wxQyAgentId,
          id: this.wxForm.wxQyAgentIdId,
          name: "wxQyAgentId"
        },
        {
          confKey: "nd.wx.qy.api",
          confVal: this.wxForm.wxQyApi,
          id: this.wxForm.wxQyApiId,
          name: "wxQyApi"
        },
        {
          confKey: "nd.wx.qy.redirectUri",
          confVal: this.wxForm.wxQyRedirectUri,
          id: this.wxForm.wxQyRedirectUriId,
          name: "wxQyRedirectUri"
        },
        {
          confKey: "nd.wx.qy.corpsecret",
          confVal: this.wxForm.wxQyCorpsecret,
          id: this.wxForm.wxQyCorpsecretId,
          name: "wxQyCorpsecret"
        },
        {
          confKey: "nd.wx.qy.syncOpen",
          confVal: this.wxForm.wxQySyncOpen,
          id: this.wxForm.wxQySyncOpenId,
          name: "wxQySyncOpen"
        }
      );
      for (let i = 0; i < formList.length; i++) {
        ndConfigList.push(formList[i]);
      }
      return ndConfigList;
    },
    getSafeParam() {
      let formList = [];
      let ndConfigList = [];
      formList.push(
        {
          confKey: "nd.jwt.token.expire",
          confVal: this.safeForm.jwtTokenExpire,
          id: this.safeForm.jwtTokenExpireId,
          name: "jwtTokenExpire"
        },
        {
          confKey: "nd.jwt.token.appExpire",
          confVal: this.safeForm.jwtTokenAppExpire,
          id: this.safeForm.jwtTokenAppExpireId,
          name: "jwtTokenAppExpire"
        },
        {
          confKey: "nd.jwt.token.expireRefresh",
          confVal: this.safeForm.jwtTokenExpireRefresh,
          id: this.safeForm.jwtTokenExpireRefreshId,
          name: "jwtTokenExpireRefresh"
        },
        {
          confKey: "nd.jwt.token.appExpireRefresh",
          confVal: this.safeForm.jwtTokenAppExpireRefresh,
          id: this.safeForm.jwtTokenAppExpireRefreshId,
          name: "jwtTokenAppExpireRefresh"
        },
        {
          confKey: "nd.jwt.token.expireBacklist",
          confVal: this.safeForm.jwtTokenExpireBacklist,
          id: this.safeForm.jwtTokenExpireBacklistId,
          name: "jwtTokenExpireBacklist"
        },
        {
          confKey: "nd.auth.loginType",
          confVal: this.safeForm.authLoginType,
          id: this.safeForm.authLoginTypeId,
          name: "authLoginType"
        },
        {
          confKey: "nd.auth.thirdLoginOpen",
          confVal: this.safeForm.authThirdLoginOpen,
          id: this.safeForm.authThirdLoginOpenId,
          name: "authThirdLoginOpen"
        },
        {
          confKey: "nd.auth.accessWhites",
          confVal: this.safeForm.authAccessWhites,
          id: this.safeForm.authAccessWhitesId,
          name: "authAccessWhites"
        }
      );
      for (let i = 0; i < formList.length; i++) {
        ndConfigList.push(formList[i]);
      }
      return ndConfigList;
    },
    getMailParam() {
      let formList = [];
      let ndConfigList = [];
      formList.push(
        {
          confKey: "nd.mail.open",
          confVal: this.mailForm.mailOpen,
          id: this.mailForm.mailOpenId,
          name: "mailOpen"
        },
        {
          confKey: "nd.mail.host",
          confVal: this.mailForm.mailHost,
          id: this.mailForm.mailHostId,
          name: "mailHost"
        },
        {
          confKey: "nd.mail.port",
          confVal: this.mailForm.mailPort,
          id: this.mailForm.mailPortId,
          name: "mailPort"
        },
        {
          confKey: "nd.mail.user",
          confVal: this.mailForm.mailUser,
          id: this.mailForm.mailUserId,
          name: "mailUser"
        },
        {
          confKey: "nd.mail.password",
          confVal: this.mailForm.mailPassword,
          id: this.mailForm.mailPasswordId,
          name: "mailPassword"
        },
        {
          confKey: "nd.mail.sslEnable",
          confVal: this.mailForm.mailSslEnable,
          id: this.mailForm.mailSslEnableId,
          name: "mailSslEnable"
        }
      );
      for (let i = 0; i < formList.length; i++) {
        ndConfigList.push(formList[i]);
      }
      return ndConfigList;
    },
    changeOssOpen() {
      this.rules.ossEndpoint[0].required = this.fileForm.ossOpen;
      this.rules.ossAccessKey[0].required = this.fileForm.ossOpen;
      this.rules.ossAccessSecret[0].required = this.fileForm.ossOpen;
      this.rules.ossDefaultBucketName[0].required = this.fileForm.ossOpen;
      this.rules.fileUploadPath[0].required = true;
    },
    inputChangeValue(keyName, value) {
      if (keyName == "ossType") {
        this.judgeStatus();
      }
      if (keyName == "smsType") {
        this.$refs["smsForm"].clearValidate();
      }
      if (keyName == "ossType") {
        this.$refs["fileForm"].clearValidate();
      }
      if (this.smsForm.smsOpen == true) {
        this.validSms(true);
      } else {
        this.validSms(false);
        this.$refs["smsForm"].clearValidate();
      }
      if (this.pushForm.pushOpen == true) {
        this.validPush(true);
      } else {
        this.validPush(false);
        this.$refs["pushForm"].clearValidate();
      }
      if (this.mailForm.mailOpen == true) {
        this.validMail(true);
      } else {
        this.validMail(false);
        this.$refs["mailForm"].clearValidate();
      }
      if (this.smsForm.smsRetrySendTimes == null) {
        this.smsForm.smsRetrySendTimes = "";
      }
      if (this.pushForm.pushValidTime == null) {
        this.pushForm.pushValidTime = "";
      }
    },
    judgeStatus() {
      if (this.fileForm.ossType == "NORMAL") {
        this.ossNormalType = true;
        this.ossMinioType = false;
        this.ossTxType = false;
        this.ossAliType = false;
      } else if (this.fileForm.ossType == "MINIO") {
        this.ossNormalType = false;
        this.ossMinioType = true;
        this.ossTxType = false;
        this.ossAliType = false;
      } else if (this.fileForm.ossType == "TXCOS") {
        this.ossNormalType = false;
        this.ossMinioType = false;
        this.ossTxType = true;
        this.ossAliType = false;
      } else if (this.fileForm.ossType == "ALIOSS") {
        this.ossNormalType = false;
        this.ossMinioType = false;
        this.ossTxType = false;
        this.ossAliType = true;
      }
    },
    validSms(value) {
      this.rules.smsCron[0].required = value;
      this.rules.smsAliyunKey[0].required = value;
      this.rules.smsAliyunSecret[0].required = value;
      this.rules.smsAliyunDomain[0].required = value;
      this.rules.smsRetrySendTimes[0].required = value;
      this.rules.smsQcloudsKey[0].required = value;
      this.rules.smsQcloudsSecret[0].required = value;
    },
    validPush(value) {
      this.rules.pushCron[0].required = value;
      this.rules.pushValidTime[0].required = value;
      this.rules.pushJiguangKey[0].required = value;
      this.rules.pushJiguangSecret[0].required = value;
    },
    validMail(value) {
      this.rules.mailHost[0].required = value;
      this.rules.mailPort[0].required = value;
      this.rules.mailUser[0].required = value;
      this.rules.mailPassword[0].required = value;
    }
  }
};
</script>

<style lang="stylus" scoped>
#dashboard {
  .commonSearch {
    font-size: $default-font;

    .headerTitle {
      height: 100%;
      margin-top: 10px;
      margin-bottom: 10px;
      font-size: 14px;
      padding: 5px 10px;
      font-weight: bold;
      border: 1px solid $theme-color;

      i, span {
        color: $theme-color;
      }

      span {
        margin-left: 5px;
      }
    }
  }

  p {
    margin-left: 30px;
    font-size: $default-font;
  }

  p, div {
  }

  .title {
    color: $theme-color;
    font-size: $default-font;
    font-weight: bold;
  }

  .title2 {
    font-size: $default-font;
  }
}
</style>

